module.exports = __webpack_public_path__ + "static/media/hellomelon_mac.fa1dd188.png";